@if (entitiesTableByLayerService.entities().length) {
    <div class="overflow-x-auto h-full">
        @if (entitiesTableByLayerService.isLoading()) {
            <div class="m-auto h-full flex justify-center items-center">
                <app-loading />
            </div>
        } @else {
            <app-custom-table
                [columns]="tableColumns()"
                [headerCheckboxState]="entitiesTableByLayerService.headerCheckboxState()"
                [isSelectable]="canSelect()"
                [translateColumns]="false"
                (sortEvent)="onSortChange($event)"
                (toggleAllSelectedEvent)="entitiesTableByLayerService.handleHeaderCheckBox()">
                @for (
                    fieldInterventionEntity of entitiesTableByLayerService.entities();
                    track fieldInterventionEntity.id
                ) {
                    <tr
                        [class.details-opened]="fieldInterventionEntity.id === currentPanelEntity()"
                        (click)="
                            fieldInterventionService.toggleFieldInterventionEntityDetailPanel(
                                fieldInterventionEntity.id
                            )
                        ">
                        @if (canSelect()) {
                            <td
                                (click)="
                                    entitiesTableByLayerService.handleSelectEntity($event, fieldInterventionEntity)
                                ">
                                <app-checkbox
                                    [checkboxState]="
                                        entitiesTableByLayerService.rowCheckboxState()[fieldInterventionEntity.id]
                                    " />
                            </td>
                        }

                        @for (column of tableColumns(); track column.key) {
                            @if (column.key === 'status') {
                                <td>
                                    <app-field-intervention-status
                                        [size]="2"
                                        [status]="fieldInterventionEntity.status" />
                                </td>
                            } @else {
                                <td>
                                    {{ fieldInterventionEntity.dataAttributes[column.key] }}
                                </td>
                            }
                        }
                    </tr>
                }
            </app-custom-table>
        }
    </div>
} @else {
    <div class="min-h-full flex items-center justify-center">
        <app-no-data-to-display iconSize="5x" />
    </div>
}
